import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import common from './modules/common'
import site from './modules/site'
import category from './modules/category'
import goods from './modules/goods'
import carts from './modules/carts'
import farmer from './modules/farmer'
import member from './modules/member'
import standards from './modules/standards'
import activity from './modules/activity'
import settlement from './modules/settlement'
import order from './modules/order'
import recharge from './modules/recharge'
import group from './modules/group'
import discover from './modules/discover'
import search from './modules/search'
import cashier from './modules/cashier'
import article from './modules/article'
import packages from './modules/package'
import recipe from './modules/rscipe'
import events from './modules/events'
import other from './modules/other'
import about from './modules/about'

Vue.use(Vuex)

export default new Vuex.Store({
    actions,
    getters,
    modules: {
        common,
        site,
        category,
        goods,
        carts,
        farmer,
        member,
        standards,
        activity,
        settlement,
        order,
        recharge,
        group,
        discover,
        search,
        cashier,
        article,
        packages,
        recipe,
        events,
        other,
        about
    }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js